<template>
    <div class="m-auto px-8 md:px-20 pb-5">
        <div id="selectModal"></div>
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Dettaglio business unit
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <p>Business unit: <span class="font-bold">{{ bu.nome }}</span></p>
            <div class="grid grid-cols-3 gap-3 my-3">
                <div class="flex flex-col mb-3">
                    <Field field_name="Nome" v-model="bu.nome"
                           :errors="getErrors('nome')">
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Etichetta" v-model="bu.label"
                           :errors="getErrors('label')">
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Utente controllore">
                        <VueMultiselect
                            v-model="userAutocomplete.selection"
                            :options="userAutocomplete.options"
                            placeholder="Utente controllore"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="name"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="userAutocomplete.search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="col-start-1 flex flex-col">
                    <Field field_name="Utenti boards">
                        <VueMultiselect :searchable="true" :loading="boardsAutocomplete.isLoading"
                                        :internal-search="false"
                                        trackBy="id"
                                        label="nome"
                                        @search-change="boardsAutocomplete.search"
                                        v-model="boardsAutocomplete.selection"
                                        :options="boardsAutocomplete.options"
                                        :multiple="true"
                                        :close-on-select="false" :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        placeholder="Board"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:noOptions>Digita per cercare</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Visibile crm"
                           :errors="getErrors('show_crm')">
                        <Checkbox :checked="bu.show_crm"
                                  @change="bu.show_crm = !bu.show_crm" checkClass="w-4 h-4">
                        </Checkbox>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Visibile progetti"
                           :errors="getErrors('show_progetti')">
                        <Checkbox :checked="bu.show_progetti"
                                  @change="bu.show_progetti = !bu.show_progetti" checkClass="w-4 h-4">
                        </Checkbox>
                    </Field>
                </div>

                <div class="my-3 col-span-3">
                    <div class="font-bold pb-2 text-sm">Fasce di ricavo</div>
                    <div v-for="(fascia, i) in fasce" :key="i"
                         class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
                        <div class="flex flex-col">
                            <Field :label-visible="false" placeholder="Descrizione"
                                   :errors="getErrorsFasce(i, 'descrizione')"
                                   v-model="fascia.descrizione">
                            </Field>
                        </div>
                        <div class="flex flex-col">
                            <Field :label-visible="false" placeholder="Minimo"
                                   :errors="getErrorsFasce(i, 'min')"
                                   :inputAttrs="{min:0,step:'0.01'}"
                                   v-model="fascia.min" type="number">
                            </Field>
                        </div>
                        <div class="flex flex-col">
                            <Field :label-visible="false" placeholder="Massimo"
                                   :errors="getErrorsFasce(i, 'max')"
                                   :inputAttrs="{min:0,step:'0.01'}"
                                   v-model="fascia.max" type="number">
                            </Field>
                        </div>
                        <div class="flex items-center">
                            <NextButton variant="outline-secondary" @click="removeFasce(i)"
                                        class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i>
                            </NextButton>
                        </div>
                    </div>
                    <div class="flex justify-end">
                        <NextButton variant="primary" @click="addFascia"
                                    class="col flex justify-center items-center h-8 w-8"><i
                            class="icon-croce_quadrata"></i>
                        </NextButton>
                    </div>
                </div>

                <div class="">
                    <h3 class="font-bold text-center mb-2">Lista campi preventivo</h3>
                    <div class="p-3 bg-white rounded-lg shadow">
                        <draggable
                            class="divide-y-2 divide-gray-100"
                            :list="campi_preventivo"
                            group="colonne"
                            @change="log"
                            itemKey="name"
                        >
                            <template #item="{ element, index }">
                                <div class="p-1 flex justify-between" :class="getColor(element[0])">
                                    <span>{{ getDescription(element[0]) }}</span>
                                    <Checkbox :checked="element[1]"
                                              @change="element[1] = !element[1]" checkClass="w-4 h-4">
                                    </Checkbox>
                                </div>
                            </template>
                        </draggable>
                    </div>
                </div>
            </div>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import businessUnitsManager from "@/api/BusinessUnits";
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Checkbox from "@/components/Checkbox.vue";
import Autocomplete from "@/setup/Autocomplete";
import userManager from "@/api/Users";
import draggable from 'vuedraggable'
import {mapGetters} from 'vuex';
import ModalInput from "@/components/ModalInput.vue";

@Options({
    name: 'BusinessUnitsDetail',
    components: {
        ModalInput,
        Checkbox,
        MultiselectOption, NextButton,
        Loading,
        Field,
        NextTable,
        InfiniteLoading,
        draggable
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'allField',
            'cellsDescriptor',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
    }
})
export default class BusinessUnitsDetail extends Vue {
    userAutocomplete: any = setup(() => Autocomplete(userManager))
    boardsAutocomplete: any = setup(() => Autocomplete(userManager, true))
    id!: number
    allField!: string[]
    cellsDescriptor!: any
    isCellAcquisto!: any
    isCellVendita!: any
    isCellRe!: any
    isCellNe!: any
    fasce: any[] = []

    bu = {
        nome: '',
        id: 0,
        created_at: null,
        updated_at: null,
        label: '',
        show_crm: false,
        show_progetti: false,
        bu_father_id: null,
        field_default: '',
        PD1G_CODICE: '',
        controllore_user_id: null
    }
    campi_bu: any[] = []
    esito = false
    response_message = ''
    errors = {}


    campi_preventivo: any[] = []

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    getCell(prop: any) {
        return this.cellsDescriptor[prop]
    }

    addFascia() {
        this.fasce.push({descrizione: null, min: 0, max: 0})
    }

    removeFasce(idx: number) {
        this.fasce.splice(idx, 1)
    }

    getErrorsRuoli(index: string | number, field: string) {
        return (this.errors as any)[`ruoli.${index}.${field}`]
    }

    getErrorsFasce(index: string | number, field: string) {
        return (this.errors as any)[`fasce.${index}.${field}`]
    }

    getColor(prop: any) {
        const cell = this.getCell(prop)
        if (this.isCellAcquisto(cell.type)) {
            return "bg-next-acquisto"
        }
        if (this.isCellVendita(cell.type)) {
            return "bg-next-vendita"
        }
        if (this.isCellRe(cell.type)) {
            return "bg-next-acquisto"
        }
        if (this.isCellNe(cell.type)) {
            return ""
        }
    }

    getDescription(prop: any) {
        return this.getCell(prop)?.name
    }

    created() {
        this.fetchBu()
    }

    fetchBu() {
        businessUnitsManager.businessUnit(this.id).then((response) => {
            this.bu = response.data
            this.campi_bu = JSON.parse(response.data.field_default) || []
            this.campi_preventivo = this.allField.sort((a: any, b: any) => {
                return this.campi_bu.findIndex((e: any) => {
                    return e[0] == a
                }) - this.campi_bu.findIndex((e: any) => {
                    return e[0] == b
                })
            }).map((f) => {
                const campo_bu = this.campi_bu.find((e) => {
                    return f == e[0]
                })
                return [f, campo_bu != undefined && campo_bu[1]]
            })
            return this.userAutocomplete.retrieve(this.bu.controllore_user_id)
        })
        businessUnitsManager.boardUsers(this.id).then((response) => {
            this.boardsAutocomplete.options = response.data
            this.boardsAutocomplete.selection = response.data
        })

        businessUnitsManager.fasceRicavo(this.id).then((response) => {
            this.fasce = response.data
        })

        this.boardsAutocomplete.search('', 0)
        this.userAutocomplete.search('', 0)
    }

    save() {
        this.response_message = ''
        businessUnitsManager.salvaBusinessUnit(this.id, {
            nome: this.bu.nome,
            label: this.bu.label,
            show_crm: this.bu.show_crm,
            show_progetti: this.bu.show_progetti,
            bu_father_id: this.bu.bu_father_id,
            field_default: JSON.stringify(this.campi_preventivo),
            controllore_user_id: this.userAutocomplete.selection?.id || null,
            board_ids: this.boardsAutocomplete.selection.map((e: any) => e.id),
            fasce: this.fasce
        }).then(() => {
            this.errors = {}
            this.esito = true
            this.response_message = 'Salvataggio avvenuto corretamente'
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            this.esito = false
            this.response_message = 'Salvataggio fallito'
        }).finally(() => {
            scrollTo({top: 0, behavior: 'smooth'});

        })
    }

    log(evt: any) {
        // window.console.log(evt);
    }

}

</script>


<style lang="scss">

</style>
